import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IOptions } from 'src/app/core/types';
import { EmpresaService } from 'src/app/services/EmpresaService/empresa.service';
import { IPatchServicoEntradaEmpresaFaturada } from 'src/app/services/ServicoEntradaService/servicoEntrada.model';
import { ServicoEntradaService } from 'src/app/services/ServicoEntradaService/servicoEntrada.service';

@Component({
  selector: 'app-modal-empresas-faturadas',
  templateUrl: './modal-empresas-faturadas.component.html',
  styleUrls: ['./modal-empresas-faturadas.component.scss']
})
export class ModalEmpresasFaturadasComponent implements OnInit {
  form: FormGroup;
  // permissionToken: string = '';
  isLoading: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalEmpresasFaturadasComponent>,
    private fb: FormBuilder,
    private empresaService: EmpresaService,
    private servicoEntradaService: ServicoEntradaService
  ) {
    this.form = this.initForm();
  }

  ngOnInit(): void {
    this.activateRoute();
    this.carregarEmpresas();
  }

  tableData: any[] = [];

  tableColumns = [
    {
      header: 'Empresas Faturadas',
      key: 'empresa',
      type: 'text'
    },
    {
      header: '',
      key: 'selecionar',
      type: 'checkbox',
      action: (item: any) => this.selectEmpresa(item)
    }
  ];

    empresaOptions: IOptions[] = [
    {
      name: '',
      value: ''
    }
  ];

  initForm(): FormGroup {
    const form = this.fb.group({
      FK_GATE_ENTR: [null, [Validators.required]],
      FK_EPSA: [null, [Validators.required]],
      NM_EPSA: ['', []],
      // TX_CPF_MTRT: ['', [Validators.required, Validators.minLength(11)]]
    });
    return form;
  }

  postEmpresaFaturada() {
    this.isLoading = true;
    const payload = this.createPayload();
    this.servicoEntradaService.PatchServicoEntradaEmpresaFaturada(payload).subscribe({
      next: () => {
        this.dialogRef.close(true);
      },
      error: err => {
        this.isLoading = false;
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  getEmpresas(): void {
    const nomeEmpresa = this.form.controls['NM_EPSA'].value;
    if (!nomeEmpresa) {
      this.tableData = [];
      return;
    }
    this.empresaService.GetEmpresaByFilter(nomeEmpresa, 0, 10000).subscribe({
      next: res => {
        this.tableData = res.ITEMS.map((x: any) => {
          return {
            id: x.PK_EPSA,
            empresa: x.NM_FNTS_EPSA,
            selecionar: false
          };
        });
      },
      error: err => {},
      complete: () => {}
    });
  }

  selectEmpresa(item: any) {
    this.tableData = this.tableData.map((x: any) => {
      return {
        ...x,
        selecionar: x.id === item.id ? true : false
      };
    });

    const idEmpresa = item.id;
    this.form.controls['FK_EPSA'].setValue(idEmpresa);
  }

  createPayload(): IPatchServicoEntradaEmpresaFaturada {
    return {
      EmpresaFaturadaId: this.form.controls['FK_EPSA'].value,
      ServicoEntradaIds: this.data.servicosEntrada,
      FK_FUNC_OPER: Number(localStorage.getItem('id'))
    };
  }

  onCancelar(): void {
    this.dialogRef.close();
  }

  onAcessar(): void {
    this.dialogRef.close();
  }

  private activateRoute(): void {
    if (this.data && this.data.id /*&& this.data.permissionToken*/) {
      // this.permissionToken = this.data.permissionToken;
      this.form.controls['FK_GATE_ENTR'].setValue(this.data.id);
    }
  }

  private carregarEmpresas(): void {
    this.empresaService
      .GetEmpresaByFilter(undefined, 1, 10000, 3)
      .subscribe({
        next: (response) => {
          this.empresaOptions = response.ITEMS.map(e => ({
            name: e.NM_FNTS_EPSA,
            value: e.PK_EPSA
          }));
        },
        error: (err) => {
          console.error('Erro ao carregar empresas', err);
        }
      });
  }

  public escolherEmpresa(value: any): void {
    this.form.controls['FK_EPSA'].setValue(value);
  }
}
